<template>
  <div>
    <!-- 多语言切换按钮 -->
    <el-dropdown
      class="set-lang"
      @click.native="handleDropdown"
      @command="handleSetLang"
    >
      <el-button type="primary" ref="btn1">
        {{ $store.getters.language === "zh_cn" ? "中文" : "English" }}
      </el-button>
      <el-dropdown-menu
        slot="dropdown"
        class="lang-dropdown"
        :append-to-body="false"
        ref="downdiv"
        v-show="show"
      >
        <el-dropdown-item command="en_us">English</el-dropdown-item>
        <el-dropdown-item command="zh_cn">中文</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div ref="newSpace"></div>
  </div>
</template>
<script>
export default {
  name: "LangSelect",
  data() {
    return {
      urlPath: window.location.href,
      show: true,
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
  },
  methods: {
    handleSetLang(lang) {
      this.$i18n.locale = lang;
      this.urlPath = window.location.pathname;
      this.$store.dispatch("app/setLanguage", lang);

      // 如果url包含语言,就刷新页面
      if (this.urlPath.indexOf("zh_cn") > -1 || this.urlPath.indexOf("en_us") > -1) {
        // 如果url包含语言，但不是当前语言
        if (this.urlPath.indexOf(lang) == -1) {
          let pathnameNew = this.sliceURL(this.urlPath, lang).join("/");
          let urlNew =
            window.location.protocol +
            "//" +
            window.location.host +
            "" +
            pathnameNew;

          window.location.replace(urlNew); //刷新页面
        }
      }
      this.$message({
        message: "设置语言成功",
        type: "success",
      });
    },

    sliceURL(url, lang) {
      let arr = url.split("/");
      if (!arr.includes(lang)) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] === "zh_cn" || arr[i] === "en_us") {
            arr[i] = lang;
          }
        }
      }
      return arr;
    },

    handleDropdown() {
      this.show = true; //显示下拉框
    },
  },
};
</script>
<style lang="scss" scoped>
// 隐藏小三角
:deep(.popper__arrow) {
  display: none !important;
}
.set-lang {
  // 按钮
  :deep(.el-button--primary) {
    background-color: transparent;
    border: 1px solid #fff;
    border-radius: 6px;
    color: #fff;
    height: 30px;
    width: 82px;
    padding: 5px 10px;
  }

  .el-dropdown-menu__item:not(.is-disabled):hover,
  .el-dropdown-menu__item:focus {
    width: 100%;
    background-color: #dfebf9;
    color: #14487b !important;
  }
  :deep(.el-dropdown-menu--medium) {
    padding: 0px;
  }

  .el-dropdown-menu__item:not(.is-disabled):hover,
  .el-dropdown-menu__item:focus {
    &:first-child {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
    &:last-child {
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
  .el-dropdown-menu__item {
    color: #01579b;
  }
}
.lang-dropdown {
  display: block;
  width: 82px !important;
  top: 58px !important;
  border-radius: 6px;
}
</style>